// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__3XpdN","infoBtn":"quickbooks_infoBtn__3rszc","formBox":"quickbooks_formBox__xACQD","formFooter":"quickbooks_formFooter__3RdRr"};